module.exports = __webpack_public_path__ + "static/media/main3.8f026041.png";